import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';
import { User } from '../types';
import { StorageService } from '../services/storage.service';

interface UseAuthReturn {
    currentUser: User | null;
    login: (user: User) => void;
    logout: () => void;
    isAuthenticated: boolean;
}

/**
 * Custom hook for authentication management
 * Handles login, logout, and session persistence
 */
export const useAuth = (): UseAuthReturn => {
    const [currentUser, setCurrentUser] = useState<User | null>(() => {
        // Initialize from localStorage
        return StorageService.loadCurrentUser();
    });

    // Persist current user to localStorage whenever it changes
    useEffect(() => {
        StorageService.saveCurrentUser(currentUser);
    }, [currentUser]);

    const login = (user: User) => {
        setCurrentUser(user);
    };

    const logout = async () => {
        // Sign out from Supabase
        await supabase.auth.signOut();

        // Clear local state
        setCurrentUser(null);
    };

    const isAuthenticated = currentUser !== null;

    return {
        currentUser,
        login,
        logout,
        isAuthenticated
    };
};
